"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKnownBookingType = isKnownBookingType;
exports.getBookingType = getBookingType;
exports.isRequestBooking = isRequestBooking;
exports.requiresRequestFlow = requiresRequestFlow;
exports.isInquiryBooking = isInquiryBooking;
const TDR_1 = require("../types/TDR");
function isKnownBookingType(value) {
    return TDR_1.TDR.BOOKING_TYPES.includes(value);
}
/**
 * Single source of truth for a table's booking type.
 * `bookingType` wins; `supportLargeGroup` is the legacy fallback until it is retired.
 *
 * Tables come straight out of Firestore unvalidated, so an unrecognised `bookingType`
 * is treated as unset rather than passed through mistyped as a TDR.BookingType.
 */
function getBookingType(table) {
    if (isKnownBookingType(table === null || table === void 0 ? void 0 : table.bookingType)) {
        return table.bookingType;
    }
    return (table === null || table === void 0 ? void 0 : table.supportLargeGroup) ? 'request' : 'instant';
}
function isRequestBooking(table) {
    return getBookingType(table) === 'request';
}
/**
 * True when the booking type routes through the large-group / request flow:
 * items[].request = true and reservation.isLargeGroup = true. Both 'request'
 * and 'inquiry' do; only 'instant' does not. This is the correct predicate for
 * every "is this a large group?" call site — isRequestBooking (=== 'request')
 * is the narrower literal predicate.
 */
function requiresRequestFlow(table) {
    return getBookingType(table) !== 'instant';
}
/** True only for the 'inquiry' booking type (routes to Tripleseat per-table). */
function isInquiryBooking(table) {
    return getBookingType(table) === 'inquiry';
}
//# sourceMappingURL=bookingType.js.map